import * as React from 'react'

const BarchartInfoLogo = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={24}
			height={24}
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='currentColor'
			{...props}
		>
			<circle cx='12' cy='12' r='9' strokeWidth='2' />

			<path d='M12 17V11' strokeWidth='2' strokeLinecap='round' />

			<circle cx='12' cy='7' r='0.5' color='currentColor' strokeWidth='1' />
		</svg>
	)
}

export default BarchartInfoLogo
